import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { CustomPickList } from "../../../../../../Shared/Components/CustomPickList";
import { useToast } from "../../../../../../Shared/hook/useToast";
import { OfferUpdateSlider } from "../../../../Domain/Model/Offer";
import { Products } from "../../../../Domain/Model/Products";
import OffersPromoViewModel from "../../OffersPromoViewModel";


export const FormBuilderTypeOfferSlider = () => {

    
    const { id } = useParams(); 
    // const toast = useRef(null);
    const { showSuccess, showError, showWarn, showInfo } = useToast();
    const [colorSubmit, setColorSubmit] = useState<string>('dark');
    const [stateBtn, setStateBtn] = useState<String>("disabled");
    const [status, setStatus] = useState<boolean>(false);
    const [nameAction, setNameAction] = useState("Crear");

    const title = `${nameAction} nuevo Carrusel`

    const [viewInUpdate, setViewInUpdate] = useState<boolean>(false);
    const navigate = useNavigate();

    const [totalItems, setTotalItems] = useState(0);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [pageSize, setPageSize] = useState(10);

    const [titleInput, setTitleInput] = useState<string>('');
    const [subtitleInput, setSubtitleInput] = useState<string>('');

    const [selectedProducts, setSelectedProducts] = useState<Number[]>([]);
    const [delectedProducts, setDelectedProducts] = useState<Number[]>([]);

    const [listObtained, setListObtained] = useState<Products[]>([]);

    const defaultValues = {
        id: Number(id),
        title: "",
        subtitle: "",
        TypeOfferImages: 200,
        ProductIds: selectedProducts,
        //delectedItems: delectedProducts,
    };

    const {
        getProducts,
        products,
        getSliderById,
        createOffer,
        updateSliderOffer
        } = OffersPromoViewModel();

    const loadProducts = async (page: number, size: number, search: string = '') => {
        const result = await getProducts(page, size, search);
        setTotalItems(result.totalCount);
    };

    useEffect(() => {
        console.log("Products", products);
        loadProducts(page, pageSize, search); 
    }, [page, pageSize, search]);

    useEffect(() => {

        console.log("selectedProducts: ", selectedProducts);
        
    }, [selectedProducts]);

     useEffect(() => {
        if (id) {
            fetchSliderImage();
        }
    }, [id]);


    const fetchSliderImage = async () => {
            try {
                // 1. Obtener datos del producto
                 const data = await getSliderById(Number(id)) as OfferUpdateSlider;
    
                    if (data) {
                    // banner es de tipo Banner aquí
                    console.log(data);
                    setTitleInput(data.Title);
                    setSubtitleInput(data.SubTitle);

                    setListObtained(data.OfferItems);
                }
                
                if (!data) {
                    throw new Error("No se encontraron datos del producto");
                }
    
                // 2. Validar URLs de imágenes
                // if (!data.imagePrimary || !data.imageSecondary) {
                //     throw new Error("Faltan URLs de imágenes en los datos recibidos");
                // }
    
                // 3. Convertir URLs a File objects
                // const [fileweb, filemobile] = await Promise.all([
                //     urlToFile(data.imagePrimary, "banner-web.png", "image/png"),
                //     urlToFile(data.imageSecondary, "banner-mobile.png", "image/png")
                // ]);
    
                // 4. Validar archivos creados
                // if (!fileweb || !filemobile) {
                //     throw new Error("Error al convertir las imágenes");
                // }
    
                // if(!data.products){
                //     throw new Error("Error al obtener productos");
                // }
    
    
            } catch (error) {
                console.error("Error en fetchAndSetImage:", error);
                // Mostrar notificación al usuario
                showError('Error','No se pudieron cargar las imágenes del banner');
            }
        };



     const onSubmit = async(
        data: {
            id?: any,
            title: any,
            subtitle:any,
            TypeOfferImages: any,
            ProductIds: any,
            //delectedItems: any,
        }
        ) => {
            
            // console.log(data);
            try {
                
                if(nameAction==="Crear") {
                    
                    const response = await createOffer(data);
                    // console.log("Producto creado con ID:", productId);
                    if (response) {
                        showSuccess("Se registro", data.title);
                        setColorSubmit("success");
                        setTimeout(() => setColorSubmit("dark"), 3000);
                        setStateBtn("");
                        reset();

                        setTimeout(() => {
                            return navigate(`/type-offers`);
                        }, 4000);
                        
                       
                    }
                } else if(nameAction==="Editar") {

                    // console.log("Editar");
                   
                    const updateValid:any = await {};
                   
                    if(updateValid===true){
                        
                        showSuccess("Se actualizo", data.title);
                        setColorSubmit("success");
                        setTimeout(() => setColorSubmit("dark"), 3000);
                        setStateBtn("");
                        setTimeout(() => {
                            return navigate(`/type-offers`);
                        }, 4000);
                        reset({
                            id: Number(id),
                            title: "",
                            subtitle: "",
                            TypeOfferImages: 0,
                            ProductIds: [],
                            //delectedItems: [],
                        });
                    }
                    
                } 
            } catch (error) {
                console.error("Error al crear el producto:", error);
                //setColorSubmit("danger");
            }
    };

    const {
            control,
            formState: { errors },
            //handleSubmit,
            reset,
            setValue,
            watch 
        } = useForm({ defaultValues });

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
    
        const formData = new FormData();
        const typeOffer = 200;
        
        // 1. Añadir los campos de texto
        formData.append('Title', titleInput || "");
        formData.append('SubTitle', subtitleInput || "");
        formData.append('TypeOfferImages',typeOffer.toString());

        if( selectedProducts.length > 0 ) {

             if (selectedProducts) selectedProducts.forEach((idPro: Number) => formData.append('ProductsToAdd[]', idPro.toString()));
             if (delectedProducts) delectedProducts.forEach((idPro: Number) => formData.append('DetailsToRemove[]', idPro.toString()));
    
            // Aquí envías formData a tu API con axios o fetch
            for (const pair of formData.entries()) {
                console.log("ID IMAGES", `${pair[0]}:`, pair[1]);
            }

            if(Number(id)>0){
                
                const update = await updateSliderOffer(Number(id), formData);
        
              
                if(update){
                showSuccess("Se registro", "Se ha Actualizado con éxito!");
                setTimeout(() => {
                    return navigate(`/type-offers`);
                }, 4000);
            
                }else{
                showError("Error al crear", "No se pudo crear!");
                }
            } else {

                const AddForm = await createOffer(formData);
        
              
                if(AddForm){
                showSuccess("Se registro", "Se ha creado con éxito!");
                setTimeout(() => {
                    return navigate(`/type-offers`);
                }, 4000);
            
                }else{
                showError("Error al crear", "No se pudo crear!");
                }
            }
         }
  
         
            // formData.append('ProductId', JSON.stringify(elementImage));

            //  const updateForm = await updateBannerSingle(Number(id), formData);
            //  if(updateForm===true){
            //     show("success", "Se actualizo", "Se Actualizaron con éxito!");
            //     setTimeout(() => {
            //         return navigate(`/banner-form`);
            //     }, 4000);

            // } else {
            //     show("error", "Error al actualizar", "No se pudo actualizar!");
            // }
    };



    // const show = ( severity: any = '', summary: any = '', detail: any = '') => {
    //     // @ts-ignore
    //     toast.current.show({ severity: `${severity}`, summary: `${summary}`, detail: `${detail}`});
    // };
        
    return(
        <div className='container-fluid'>
            <div className="block-header">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-start">
                        <h2>Ofertas y promociones</h2>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <a href="/home" className="text-danger"><FontAwesomeIcon icon={icon({name: 'home'})} /></a>
                            </li>
                             <li className="breadcrumb-item">
                                <a href="/type-offers" className="text-danger">Tipo de ofertas</a>
                            </li>
                            <li className="breadcrumb-item">{title}</li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="d-flex flex-row-reverse">
                            
                            <div className="p-2 d-flex">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='title-report'>
                    {title}
                </div>
            </div>
            {/* <Toast ref={toast} /> */}
            <form onSubmit={handleSubmit} encType="multipart/form-data" className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="form-text-fields mb-4">
                        <div className="form-group mb-2">
                            {/* <Controller
                                name="title"
                                control={control}
                                rules={{}}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label className="mb-2" htmlFor={field.name}>
                                            Título
                                        </label>
                                        <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.invalid }, 'form-control')}  placeholder="Ingrese el título" />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            /> */}

                            <label className="mb-2" htmlFor="title">
                                Título
                            </label>
                            <input
                                type="text"
                                id="title"
                                className="form-control"
                                value={titleInput}
                                onChange={(e) => setTitleInput(e.target.value)}
                                placeholder="Ingrese el título principal"
                            />
                        </div>
                        <div className="form-group mb-2">
                            {/* <Controller
                                name="subtitle"
                                control={control}
                                rules={{ }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label className="mb-2" htmlFor={field.name}>
                                            Subtítulo
                                        </label>
                                        <InputText  id={field.name} name={field.name} value={field.value}  onChange={(e) => field.onChange(e.target.value)} className={classNames({ 'p-invalid': fieldState.invalid }, 'form-control')}  placeholder="Ingrese el subtitulo" />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            /> */}
                            <label className="mb-2" htmlFor="subtitle">
                                Subtítulo
                            </label>
                            <input
                                type="text"
                                id="subtitle"
                                className="form-control"
                                value={subtitleInput}
                                onChange={(e) => setSubtitleInput(e.target.value)}
                                placeholder="Ingrese un subtítulo"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <CustomPickList
                        data={products}
                        pageSize={10}
                        sourceSearchValue={search}
                        sourcePage={page + 1}
                        sourceTotalCount={totalItems}
                        onSourceSearchChange={(value) => {
                            setSearch(value);
                            setPage(0);
                            loadProducts(0, 5, value);
                        }}
                        onSourcePageChange={(newPage) => {
                            setPage(newPage - 1);
                            loadProducts(newPage - 1, 5, search);
                        }}
                        onChange={(selectedIds, deletedIds) => {
                            setSelectedProducts(selectedIds);
                            setDelectedProducts(deletedIds);
                        }}
                        listObtained={listObtained}
                    />
                </div>
                <div className='btn-float-content'>
                    <button type="submit" className="btn btn-dark">Guardar</button>
                </div>
            </form>
        </div>
    );
}